import React from 'react'
import CSSModules from 'helpers/CSSModulesUtil'
import styles from './styles.scss'
import ProgressBar from 'react-toolbox/lib/progress_bar';

const CardLoading = (props) => {
  return(
    <div styleName='container'>
      <ProgressBar theme={styles} type="circular" mode="indeterminate" />
    </div>
  )
}

export default CSSModules(styles)(CardLoading)